import script from "./ChooseDirectionScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseDirectionScreen.vue?vue&type=script&setup=true&lang=js"

import "./ChooseDirectionScreen.vue?vue&type=style&index=0&id=14f1453e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f1453e"]])

export default __exports__